import { Card, CardContent, Typography, Chip, Stack, Button, Box } from '@mui/material';
import { t } from 'i18next';

function LearningTagsFilterCard({ tags = [], selectedTags = [], onChange }) {

    const toggleTag = (uuid) => {
        if (selectedTags.includes(uuid)) {
            onChange(selectedTags.filter((t) => t !== uuid));
        } else {
            onChange([...selectedTags, uuid]);
        }
    };

    const clearSelection = () => {
        onChange([]);
    };

    return (
        <Card variant="outlined">
            <CardContent>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >
                    <Typography variant="h6">{t('learning.filter_by_tags')}</Typography>

                    {selectedTags.length > 0 && (
                        <Button size="small" onClick={clearSelection}>
                            {t('learning.clear_filters')}
                        </Button>
                    )}
                </Box>

                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                    {tags.map((tag) => (
                        <Chip
                            key={tag.uuid}
                            label={tag.tag}
                            clickable
                            color={
                                selectedTags.includes(tag.uuid) ? 'primary' : 'default'
                            }
                            variant={
                                selectedTags.includes(tag.uuid) ? 'filled' : 'outlined'
                            }
                            onClick={() => toggleTag(tag.uuid)}
                        />
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );
}

export default LearningTagsFilterCard;
